define([
    'moment',
], (moment) => {

    return ['LocaleService', function (LocaleService) {
        return {
            getParsedDate: getParsedDate,
            getDate: getDate,
            getMonthAsNumber: getMonthAsNumber,
            getDay: getDay,
            getYear: getYear,
            formatDate: formatDate,
            isDateValid: isDateValid,
            resetPastDateIfNeeded: resetPastDateIfNeeded,
            addDays: addDays,
            getDays: getDays,
            getMonths: getMonths,
        };


        function getParsedDate(dateAsString, dateFormat) {
            const date = moment(dateAsString, dateFormat);
            return timezoneWorkaround(date);
        }

        function formatDate(date, dateFormat) {
            return moment(date).format(dateFormat);
        }

        function getDate(year, month, day) {
            const date = moment().year(year).month(month).date(day);
            return timezoneWorkaround(date);
        }

        /**
         * this method checks if a date is valid, we have to make sure that
         * month has two digits and we have to add 1 because moment js starts with 0
         * @param year
         * @param month
         * @param day
         */
        function isDateValid(year, month, day) {
            let monthVar = month + 1;
            if (monthVar > 10) {
                monthVar = 0 + monthVar;
            }
            return moment(`${year} ${monthVar} ${day}`, 'YYYY MM DD').isValid();
        }

        function timezoneWorkaround(date) {
            return moment(date).hour(12);
        }

        function getMonthAsNumber(date) {
            return moment(date).month();
        }

        function getYear(date) {
            return moment(date).year();
        }

        function getDay(date) {
            return moment(date).date();
        }

        function resetPastDateIfNeeded(mydate) {
            const now = new Date();
            const mydatedate = new Date(mydate); //sometimes we get date as string
            if (mydatedate.getTime() < now.getTime()) {
                return now;
            }
            return mydate;
        }

        /**
         * Increments date by x number of days
         *
         * @param date Initial date. This object is not modified
         * @param numberOfDays (Integer} number of days to add
         * @returns {Date} new date object incremented by days
         */
        function addDays(date, numberOfDays) {
            if (!date) {
                return undefined;
            }
            return new Date(
                date.getFullYear(),
                date.getMonth(),
                date.getDate() + parseInt(numberOfDays),
                date.getHours(),
                date.getMinutes(),
                date.getSeconds()
            );
        }

        function getDays() {
            //display numbers from 1 to 31, to choose the day
            return _.range(1, 32, 1);
        }

        function getMonths() {
            moment.locale(LocaleService.getCurrentLocale());
            return _.map(moment.months(), (monthName, monthId) => ({
                name: monthName,
                id: monthId,
            }));
        }
    }];

});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/BaslerDateUtilService.js